import { useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'

import MultiSelectBox from '../../../../../../../../features/components/Form/MultiSelectBox'

import { getLoadOptionsHandlerCursorPagination } from '../../../../../../../../features/helpers/componentsHelpers'

import { getGoogleAdManagerCmsMetadataService } from '../../../../../../../../modules/services/rights'

import { selfAccountSelector } from '../../../../../../../../modules/selectors/selfAccounts'
import { GAM_NETWORK_CODE } from '../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'
import { CONTENT_TARGETING } from '../../../fields'

const ContentTargetingSelect = ({ formik }) => {
  const { values, setFieldValue } = formik

  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const formatOptions = useCallback(options => {
    return options.map(option => ({
      ...option,
      value: option.id,
      label: option.name
    }))
  }, [])

  const loadOptions = useMemo(() => {
    return getLoadOptionsHandlerCursorPagination({
      getOptionsService: getGoogleAdManagerCmsMetadataService,
      params: {
        network_code: gamNetworkCode,
        cms_metadata_type: 'KEYS'
      },
      formatOptions: formatOptions
    })
  }, [formatOptions, gamNetworkCode])

  return (
    <MultiSelectBox
      loadOptions={loadOptions}
      value={values[CONTENT_TARGETING]}
      name={CONTENT_TARGETING}
      setFieldValue={setFieldValue}
      placeholder="Content & Metadata"
      portaled={true}
    />
  )
}

export default ContentTargetingSelect
